import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ChangeDetectorRef } from "@angular/core";
import { FetchDataService } from "Services/fetch-data.service";
import { GridService } from "Services/grid.service";
import { EventService } from "Services/event.service";
import { User } from "Classes/User";
import { PermissionsUserRow } from "Classes/GridRows";
import { GridConfig } from "Classes/GridConfig";
import { ColModels } from "Classes/ColModels";
import { ModalConfig } from "Classes/ModalConfig";
import { IMultiSelectOption, IMultiSelectTexts, IMultiSelectSettings } from "angular-2-dropdown-multiselect";
declare var $: any;

@Component({
    selector: "manage-users",
    template: require('./manage-users.component.html'),
    styles: [require('./manage-users.component.css')]
})

export class ManageUsersComponent implements OnInit, AfterViewInit {
    constructor(
        private fetchDataService: FetchDataService,
        private gridService: GridService,
        private ColModels: ColModels,
        private eventService: EventService,
        private changeDetectorRef: ChangeDetectorRef
    ) { }

    // Errors
    userError: string = "Please Select a User.";
    submitError: string = "Submit Failed!";
    removeUserError: string = "User Removal Failed!";

    multiselectOptions: IMultiSelectOption[] = [];
    multiselectTexts: IMultiSelectTexts = {
        defaultTitle: "Edit..."
    }
    multiselectSettings: IMultiSelectSettings = {
        fixedTitle: true,

    }
    optionsModel: string[] = [];

    modalConfig: ModalConfig;
    scrolling: boolean = false;
    scrollPosition: any = {
        x: 0,
        y: 0
    }
    grid: any;
    gridConfig: GridConfig;
    gridId: string = "manage-users-grid";
    users: PermissionsUserRow[];
    colModel: any[] = this.ColModels.UsersModel;
    gridContainer: string = "manage-users-grid-container";
    gridEvents: string[] = ["selectRow", "loadComplete"];
    selectedUser: PermissionsUserRow;
    localSelectedUser: PermissionsUserRow;
    selectedUsers: PermissionsUserRow[] = [];
    filterData: any = {
        groupOp: "OR",
        rules: []
    }
    editInfoFlag: boolean = false;
    changePasswordFlag: boolean = false;
    error: boolean = false;
    errorText: string = "";
    filterQuery: string = "";

    ngOnInit(): void {
        this.users = this.fetchDataService._users;
        let apps = this.fetchDataService.getApps().filter(elem => this.fetchDataService._defaultApps.indexOf(elem.name) < 0);
        for (let i = 0; i < apps.length; i++) {
            let app = apps[i];
            this.multiselectOptions.push({ id: app.name, name: app.name })
        }
        this.gridConfig = new GridConfig(
            this.gridId,
            this.users,
            this.colModel,
            this.gridContainer,
            false
        );
        this.changeDetectorRef.detectChanges();
    }

    ngAfterViewInit(): void {
        var inputs = $(".user-management-window-container").find('select, input, textarea, button, a').filter(':visible');
        var windowInputs = $(".manage-users-container").find('select, input, textarea, button, a').filter(':visible');
        var firstInput = inputs.first();
        var lastInput = inputs.last();

        /*set focus on first input*/
        windowInputs.first().focus();

        /*redirect last tab to first input*/
        lastInput.on('keydown', function (e) {
            if ((e.which === 9 && !e.shiftKey)) {
                e.preventDefault();
                firstInput.focus();
            }
        });

        /*redirect first shift+tab to last input*/
        firstInput.on('keydown', function (e) {
            if ((e.which === 9 && e.shiftKey)) {
                e.preventDefault();
                lastInput.focus();
            }
        });
    }

    gridLoaded(grid: any): void {
        this.grid = grid;
        this.gridService.setGridEvents(this.gridEvents, this);
    }

    quickSearch(query: string): void {
        if (query) {
            this.filterData.rules = [
                {
                    data: query,
                    op: "cn",
                    field: "fName"
                },
                {
                    data: query,
                    op: "cn",
                    field: "lName"
                },
                {
                    data: query,
                    op: "cn",
                    field: "username"
                }
            ];
            let filteredUsers = this.gridService.filterData(this.filterData, this.users, this.grid);
            let column = this.grid.jqGrid('getGridParam', 'sortname');
            let order = this.grid.jqGrid('getGridParam', 'sortorder');
            this.gridService.changeGridData(filteredUsers, this.colModel, this.grid);
            this.grid.jqGrid("setGridParam", { sortorder: order });
            this.grid.jqGrid("sortGrid", column, true);

        } else {
            this.gridService.changeGridData(this.users, this.colModel, this.grid);
        }
    }

    // Grid Events

    selectRow(user: PermissionsUserRow, event: any): void {
        //if (this.selectedUser)
        //    this.selectedUser.cb = false;
        //this.selectedUser = user;
        //this.selectedUser.cb = true;
        //this.optionsModel = [];
        //if (this.selectedUser.role)
        //    try {
        //        this.optionsModel = JSON.parse(this.selectedUser.role);
        //    } catch (e) {
        //        // Shhhhhhhhh, stay quiet
        //    }
        //this.error = false;
        //this.localSelectedUser = new PermissionsUserRow(user);
        if (this.selectedUsers[0])
            this.selectedUsers[0].cb = false;
        this.selectedUsers.length = 0;
        user.cb = !user.cb;
        this.selectedUsers.push(user);
        this.optionsModel = [];
        if (user.role && this.selectedUsers.length == 1)
            try {
                this.optionsModel = JSON.parse(user.role);
            } catch (e) {
                // Shhhhhhhhh, stay quiet
            }
        this.error = false;
        this.localSelectedUser = new PermissionsUserRow(user);
    }

    editInfo(): void {
        if (this.selectedUser)
            this.editInfoFlag = true;
        else
            this.displayError(this.userError);
    }

    changePassword(): void {
        if (this.selectedUser)
            this.changePasswordFlag = true;
        else 
            this.displayError(this.userError);
    }

    confirmRemoveUser(): void {
        if (this.selectedUser) {
            this.modalConfig = new ModalConfig(
                "confirm",
                "Warning",
                "Are you sure you want to remove this user?",
                $(".manage-users-container").find('select, input, textarea, button, a').filter(':visible').last(),
                () => { },
                this.removeUser.bind(this)
            );
            this.eventService.broadcast(this.eventService._displayModal, this.modalConfig);
        } else 
            this.displayError(this.userError);
    }
    
    removeUser(): void {
        this.eventService.broadcast(this.eventService._showSpinner, "Removing from\ndatabase...");
        let ref = this;
        this.fetchDataService.removeUser(new User(this.selectedUser)).subscribe(
            (data) => {
                ref.selectedUser.cb = false;
                ref.gridService.removeGridItems([ref.selectedUser.id], ref.users);
                ref.gridService.changeGridData(ref.users, ref.colModel, ref.grid);
                ref.selectedUser = null;
                ref.localSelectedUser = null;
                ref.eventService.broadcast(ref.eventService._closeSpinner);
            }, (error) => {
                ref.selectedUser = null;
                ref.displayError(ref.removeUserError);
                ref.eventService.broadcast(ref.eventService._closeSpinner);
            });
    }

    displayError(errorText: string): void {
        this.errorText = errorText;
        this.error = true;
    }

    //updateGrid(newUserInfo: PermissionsUserRow): void {
    //    this.eventService.broadcast(this.eventService._showSpinner, "Submitting Changes...");
    //    let ref = this;
    //    this.fetchDataService.updateUserInfo(new User(newUserInfo)).subscribe(
    //        (data) => {
    //            for (let user of ref.users) {
    //                if (user.id === newUserInfo.id)
    //                    for (let key in newUserInfo) {
    //                        user[key] = newUserInfo[key];
    //                        if (key.toLowerCase() == "permission")
    //                            user[key] = Number(newUserInfo[key]);
    //                    }
    //            }
    //            ref.gridService.changeGridData(ref.users, ref.colModel, ref.grid);
    //            ref.editInfoFlag = false;
    //            ref.eventService.broadcast(ref.eventService._closeSpinner);
    //        }, (error) => {
    //            ref.selectedUser = null;
    //            ref.displayError(ref.submitError);
    //            ref.eventService.broadcast(ref.eventService._closeSpinner);
    //        });
    //    }

    submitPermissions(): void {
        if (this.selectedUsers.length > 0) {
            let selectedUserIds = [this.grid.jqGrid("getGridParam", "selrow")];
            this.fetchDataService.setRoles(selectedUserIds, this.optionsModel).subscribe(data => {
                this.selectedUsers.map(user => {
                    user.role = JSON.stringify(this.optionsModel);
                    this.grid.jqGrid("setRowData", user.id, user);
                })
            }, error => {
                console.error("Submit Permissions Failure!");
                console.error(error);
            });
        } else {

        }
        this.changeDetectorRef.detectChanges();
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./App/Components/manage-users.component.ts